import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white text-[#222222]">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <h3 className="text-3xl font-serif text-[#222222] mb-3">Clarion Psychotherapy</h3>
            <p className="text-base text-[#444444] mb-2">Cheron Allen, LCPC</p>
            <p className="text-sm italic text-coral-deep">Clarity is the first step to strategy.</p>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-base font-semibold tracking-widest uppercase text-[#222222] mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-sm text-[#444444] hover:text-coral-medium transition-colors cursor-pointer">
                  Individual Therapy
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-[#444444] hover:text-coral-medium transition-colors cursor-pointer">
                  Couples Counseling
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-[#444444] hover:text-coral-medium transition-colors cursor-pointer">
                  Clarion Clarity Method
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-[#444444] hover:text-coral-medium transition-colors cursor-pointer">
                  Intensive Programs
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="text-base font-semibold tracking-widest uppercase text-[#222222] mb-4">Resources</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/faq" className="text-sm text-[#444444] hover:text-coral-medium transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-sm text-[#444444] hover:text-coral-medium transition-colors cursor-pointer">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/approach" className="text-sm text-[#444444] hover:text-coral-medium transition-colors cursor-pointer">
                  Our Approach
                </Link>
              </li>
            </ul>
            <div className="mt-6 space-y-2">
              <p className="text-xs text-coral-deep">Privacy Policy</p>
              <p className="text-xs text-coral-deep">Terms of Service</p>
              <p className="text-xs text-coral-deep">Telehealth Consent</p>
            </div>
          </div>

          {/* Contact & CTA Column */}
          <div>
            <h4 className="text-lg font-serif text-[#222222] mb-4">Ready to Begin?</h4>
            <p className="text-sm text-coral-deep mb-2">
              <a href="mailto:cheron@clarionpsychotherapy.com" className="hover:text-coral-medium underline cursor-pointer">
                cheron@clarionpsychotherapy.com
              </a>
            </p>
            <p className="text-sm text-[#444444]">(773) 207-5400</p>
            <p className="text-sm text-[#444444] mb-6">@clarionpsychotherapy</p>
            <Link
              to="/consultation"
              className="inline-block px-8 py-4 bg-coral-medium text-white rounded-full text-sm font-medium hover:bg-coral-deep transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Book Consultation
            </Link>
          </div>
        </div>

        {/* Separator */}
        <div className="border-t border-divider pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
            <p className="text-sm text-[#444444] text-center md:text-left">
              © 2025 Clarion Psychotherapy. Virtual sessions across Illinois.
            </p>
            <p className="text-sm text-[#444444] text-center md:text-right">
              Crisis support: <span className="font-semibold">988</span> | <span className="font-semibold">911</span>
            </p>
          </div>

          {/* Emergency Disclaimer */}
          <div className="text-center">
            <p className="text-xs text-coral-deep leading-relaxed max-w-4xl mx-auto">
              Clarion Psychotherapy does not provide emergency services. If you are experiencing a mental health emergency, please call 988 (Suicide & Crisis Lifeline), 911, or go to your nearest emergency room.
            </p>
          </div>
        </div>
      </div>

    </footer>
  );
}
